import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MobileHelper } from './core/helpers/mobile-helper';
import { AuthService } from './core/services/auth/auth.service';
import { BomCookieService } from './core/services/bom-cookie/bom-cookie.service';
import { MonitoringService } from './core/services/monitoring/monitoring.service';
import { UserManagerAccessorService } from './core/services/oidc/user-manager-accessor.service';
import { OperatingStatusService } from './core/services/operating-status/operating-status.service';
import { AttachOperationsService } from './core/services/operations/attach-operations/attach-operations.service';
import { GenberegnOperationsService } from './core/services/operations/genberegn/genberegn-operations.service';
import { SaveOperationsService } from './core/services/operations/save/save-operations.service';
import { ThemeService } from './core/services/theme/theme.service';
import { CurrentSagService } from './projekter/services/current-sag/current-sag.service';
import { MineProjekterService } from './projekter/services/mine-projekter/mine-projekter.service';
import { SkiftBrugerService } from './projekter/skift-bruger.service';

@Component({
  selector: 'bom-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  themeCss: SafeResourceUrl;
  isMobileMode = MobileHelper.isMobile();
  isMobileSigning$ = new BehaviorSubject<boolean>(false);
  isMobileSigningOn = true;

  constructor(
    private authService: AuthService,
    private attachOperationsService: AttachOperationsService,
    private mineProjekterService: MineProjekterService,
    private operatingStatusService: OperatingStatusService,
    private sanitizer: DomSanitizer,
    private saveOperationsService: SaveOperationsService,
    private genberegnOperationService: GenberegnOperationsService,
    private userManagerAccessorService: UserManagerAccessorService,
    private themeService: ThemeService,
    private currentSagService: CurrentSagService,
    private monitoringService: MonitoringService,
    private skiftBrugerService: SkiftBrugerService,
    private bomCookieService: BomCookieService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // NB: Only put essentials needed for application startup here
    this.monitoringService.initialize();
    this.userManagerAccessorService.initialize();
    this.bomCookieService.initialize();
    this.authService.initialize();
    this.saveOperationsService.initialize();
    this.genberegnOperationService.initialize();
    this.attachOperationsService.initialize();
    this.mineProjekterService.initialize();
    this.themeService.initialize();
    this.operatingStatusService.initialize();
    this.currentSagService.initialize();
    this.skiftBrugerService.intialize();

    this.themeService.themeCss$.subscribe(themeCss => {
      this.themeCss = this.sanitizer.bypassSecurityTrustResourceUrl(
        '/assets-css-' + themeCss + '.css'
      );

      setTimeout(() => {
        document.body.classList.add('ready');
      }, 200);
    });

    this.themeService.setThemefromReferrer(document.referrer);

    if (this.isMobileMode && this.isMobileSigningOn) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (event.url.includes('digitalsignering')) {
            this.isMobileSigning$.next(true);
          } else {
            this.isMobileSigning$.next(false);
          }
        }
      });
    }
  }
}
